// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_3bFwT","startPage":"style_startPage_-KzjX"};